export const JollyPhonicData = [
  {
    group: 1,
    color: "#ff5757",
    items: [
      {
        title: `S`,
        audioUrl: require("../audios/s.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1ga7r3Ty7yvmHI9U64qLamkRnHEGftdKy=s1000?authuser=0'
      },
      {
        title: `a`,
        audioUrl: require("../audios/a.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1K5xoO75mGJMk43rIC5ZSH6vogOTwa99Y=s1000?authuser=0'
      },
      {
        title: `t`,
        audioUrl: require("../audios/t.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1c9G00sTLbRh77HC-V5NGZK1pxxNyfbgy=s1000?authuser=0'
      },
      {
        title: `i`,
        audioUrl: require("../audios/i.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1Gl48vJWpao9fU_7IUOuqEZJy0ReT1Ti9=s1000?authuser=0'
      },
      {
        title: `p`,
        audioUrl: require("../audios/p.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1p1Ywzy9lbtB1nj3pVP4h_Ddr24S4jJki=s1000?authuser=0'
      },
      {
        title: `n`,
        audioUrl: require("../audios/n.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1ECQyLCQF-7vMlcFnTWfPbo4_OiU-vQk6=s1000?authuser=0'
      }
    ]
  },
  {
    group: 2,
    color: "#cb6ce6",
    items: [
      {
        title: `ck`,
        audioUrl: require("../audios/ck.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1k8ljXq8P4TkVI-ilQ_zU6vkLqgAIcEbr=s1000?authuser=0'
      },
      {
        title: `e`,
        audioUrl: require("../audios/e.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1DUQBKQvtDhQTtHPYwTCmUAqPOOoUTvxn=s1000?authuser=0'
      },
      {
        title: `h`,
        audioUrl: require("../audios/h.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1vM-L4YP5tw3AsJOLX8pYvcKRzxyBYsJp=s1000?authuser=0'
      },
      {
        title: `r`,
        audioUrl: require("../audios/r.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1TLoJ3YsX7HPyHPiXDCEoC0jjOKEB-w6t=s1000?authuser=0'
      },
      {
        title: `m`,
        audioUrl: require("../audios/m.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1cMWxLOiVgFut2JmqYpE7dkYjg8C66VQC=s1000?authuser=0'
      },
      {
        title: `d`,
        audioUrl: require("../audios/d.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1zGuD96xpth4KMSVDy0MpgzOOLy0i8tSD=s1000?authuser=0'
      }
    ]
  },
  {
    group: 3,
    color: "#1CBDFF",
    items: [
      {
        title: `g`,
        audioUrl: require("../audios/g.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1mLxGQbX7X9DRhE-6dn7XEqSs1WhbxXrY=s1000?authuser=0'
      },
      {
        title: `o`,
        audioUrl: require("../audios/o.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1wBv_h_asE5pcUkuNffZ54pyT4kKng75e=s1000?authuser=0'
      },
      {
        title: `u`,
        audioUrl: require("../audios/u.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/15iUF1FkIdIWlYHB3OgKObHGWl92IO43s=s1000?authuser=0'
      },
      {
        title: `l`,
        audioUrl: require("../audios/l.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/10tee9o4EdyTPLzeQAvdUgwP1xA1R0Hg7=s1000?authuser=0'
      },
      {
        title: `f`,
        audioUrl: require("../audios/f.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/1rsvxx1DK6l97-Fh8vEw_AW-W0CM8443G=s1000?authuser=0'
      },
      {
        title: `b`,
        audioUrl: require("../audios/b.mpeg"),
        thumbnail: 'https://lh3.googleusercontent.com/d/11JAvSzlq8BNzCYZpYuOLki_sq1lXbc9t=s1000?authuser=0'
      }
    ]
  },
];